import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import LaddaButton from "../../../components/buttons/laddaButton";
import {
  callActionApiAsync,
  postRespondInspectionRecord
} from "../../../services/apiService";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ModalComponent from "../../../components/modals";
import { inspectionRecordProcess } from "../../../constants/enums";

const validationSchema = yup.object().shape({});

const DeclineInspectionRecordModal = ({
  open,
  close,
  bioEquipmentId,
  inspectionRecordId,
  comments,
  onRejected,
  onError,
  userId,
  onStart,
  onFinish
}) => {
  const submitLockRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    control,
    formState: { errors },
    getValues,
    reset,
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all"
  });
  useEffect(() => {
    if (!open) return;
    loadData();
  }, [open]);

  const onSubmit = async () => {
    if (submitLockRef.current || (onStart && !onStart())) return;
    submitLockRef.current = true;
    setIsSubmitting(true);
    let succeeded = false;
    try {
      const objToSend = {
        requestId: crypto.randomUUID(),
        userId,
        comments: getValues("comments"),
        biomadicalEquipmentId: bioEquipmentId,
        inspectionRecordId: inspectionRecordId,
        state: inspectionRecordProcess.pending
      };
      await callActionApiAsync(
        () => postRespondInspectionRecord(objToSend),
        async () => {
          succeeded = true;
          await onRejected?.(getValues("comments"));
        },
        (error) => onError?.(error, "Error al rechazar", "No se pudo rechazar el acta de inspección. Intenta nuevamente.")
      );
    } catch (error) {
      onError?.(error, "Error al rechazar", "No se pudo rechazar el acta de inspección. Intenta nuevamente.");
    } finally {
      submitLockRef.current = false;
      setIsSubmitting(false);
      onFinish?.();
    }
    if (succeeded) handleClose();
  };

  const loadData = () => {
    setValue("comments", comments);
  };
  const cleanData = () => {
    setValue("comments", "");
  };

  const handleClose = () => {
    if (submitLockRef.current) return;
    cleanData();
    reset();
    close();
  };

  return (
    <div>
      <ModalComponent
        open={open}
        handleClose={() => {
          handleClose();
        }}
        title={"Rechazar acta"}
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <Grid container className="mv-25 min-w-700">
          <Grid item xs={12} md={12}>
            <div className="VContainer j-center w-675">
              <p className="text-form-label" style={{ marginLeft: "10px" }}>
                Comentario:
              </p>
              <FormTextField
                name="comments"
                control={control}
                isTextArea={true}
                rows={2}
                disabled={isSubmitting}
              />
              <div className="HContainer j-center mv-25">
                <LaddaButton
                  width={"160px"}
                  fontSize={"12px"}
                  height={"40px"}
                  variant="contained"
                  backgroundColor={"#F43F5E"}
                  disabled={isSubmitting}
                  loading={isSubmitting}
                  onClick={onSubmit}
                >
                  <p className="button_text">Rechazar</p>
                </LaddaButton>
              </div>
            </div>
          </Grid>
        </Grid>
      </ModalComponent>
    </div>
  );
};

export default DeclineInspectionRecordModal;
